export default {"src":"/_next/static/media/sort-icon.ed110f88.svg","height":16,"width":17,"blurWidth":0,"blurHeight":0};